<template>
  <div class="grid">
	<template v-if="loader==true">
		<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em" />
		</div>
	</template>
	<div class="field col-12 text-center">
		<DataTable :value="Documentos" let-i="rowIndex" v-model="table_documentos" :paginator="true" :rows="5" responsiveLayout="scroll">
			<Column field="documento" header="Documento" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.documento}}
				</template>
			</Column>
			<Column field="estado" header="Estado" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.estado}}
				</template>
			</Column>
			<Column field="fecha" header="Fecha" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.fecha}}
				</template>
			</Column>
			<Column field="numero" header="Numero" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.numero}}
				</template>
			</Column>
			<Column field="sucursal" header="Sucursal" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.sucursal}}
				</template>
			</Column>
			<Column field="url" header="Ver Documento" :sortable="false">
				<template #body="slotProps">
					<template v-if="slotProps.data.url==''">
						<a @click="url_vacia" rel="noopener noreferrer"><i class="pi pi-cloud-download grey-color-300 ml-1 mt-1" style="font-size: 2rem"></i></a>
					</template>
					<template v-else>
						<a :href="slotProps.data.url" target="_blank" rel="noopener noreferrer"><i class="pi pi-cloud-download blue-color ml-1 mt-1" style="font-size: 2rem"></i></a>
					</template>
				</template>
			</Column>
		</DataTable>
	</div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			message: [],
			// documentos: [],
			table_documentos: null,
			loader: false,
			loading: false,
		}
	},
	props: ['Documentos'],
	// },
  	mounted(){
		// this.loadGeneradores();
	},
	methods:{
		url_vacia(){
			this.$toast.add({severity:'error', summary: 'No hay archivo', detail:'No se ha subido el archivo a systram', life: 4000});
		}
	}
};
</script>